import SettingIcon from 'assets/images/building/setting_icon.png';
import CoinIcon from 'assets/images/building/coin_icon.png';
import RentIcon from 'assets/images/building/rent_icon.png';

import Step0 from 'assets/images/building/step0.png';
import Step1 from 'assets/images/building/step1.png';
import Step2 from 'assets/images/building/step2.png';
import Step3 from 'assets/images/building/step3.png';
import Step4 from 'assets/images/building/step4.png';
import Step5 from 'assets/images/building/step5.png';
import Step6 from 'assets/images/building/step6.png';
import Step7 from 'assets/images/building/step7.png';
import Step8 from 'assets/images/building/step8.png';
import Step9 from 'assets/images/building/step9.png';
import Step10 from 'assets/images/building/step10.png';
import useTargetStore from '@/store/target';

const stepImages = [
  {
    img: Step0,
    setting: 'hidden',
    coin: 'hidden',
    rent: 'hidden',
    title: 'Season 1. Gangnam-gu, Seoul',
  },
  {
    img: Step1,
    setting: 'hidden',
    coin: 'top-[12%] right-[16%]',
    rent: 'hidden',
    title: 'Season 1. Gangnam-gu, Seoul',
  },
  {
    img: Step2,
    setting: 'top-[12%] right-[16%]',
    coin: 'hidden',
    rent: 'hidden',
    title: 'Season 1. Gangnam-gu, Seoul',
  },
  {
    img: Step3,
    setting: 'hidden',
    coin: 'top-0 right-[16%]',
    rent: 'hidden',
    title: 'Season 1. Gangnam-gu, Seoul',
  },
  {
    img: Step4,
    setting: 'hidden',
    coin: 'hidden',
    rent: 'top-0 right-[16%]',
    title: 'Season 1. Gangnam-gu, Seoul',
  },
  {
    img: Step5,
    setting: 'top-[12%] left-[16%]',
    coin: 'hidden',
    rent: 'hidden',
    title: 'Season 1. Gangnam-gu, Seoul',
  },
  {
    img: Step6,
    setting: 'hidden',
    coin: '-top-[16%] left-[16%]',
    rent: 'hidden',
    title: 'Season 1. Gangnam-gu, Seoul',
  },
  {
    img: Step7,
    setting: 'hidden',
    coin: 'hidden',
    rent: '-top-[16%] left-[16%]',
    title: 'Season 1. Gangnam-gu, Seoul',
  },
  {
    img: Step8,
    setting: '-top-[10%] left-[43%]',
    coin: 'hidden',
    rent: 'hidden',
    title: 'Season 1. Gangnam-gu, Seoul',
  },
  {
    img: Step9,
    setting: 'hidden',
    coin: '-top-[10%] left-[43%]',
    rent: 'hidden',
    title: 'Season 1. Gangnam-gu, Seoul',
  },
  {
    img: Step10,
    setting: 'hidden',
    coin: 'hidden',
    rent: '-top-[10%] left-[43%]',
    title: 'Season 1. Gangnam-gu, Seoul',
  },
];

export default function Step({ step }: { step: number }) {
  const { title, step: steps } = useTargetStore();
  const { img: stepImg, setting, coin, rent } = stepImages[step];
  if (steps !== 0 && step === 0) {
    step = steps;
  }
  return (
    <>
      <div className="relative mx-auto max-w-[240px]">
        <img src={stepImg} className="w-full" alt={`Step ${step}`} />

        <img src={SettingIcon} className={`absolute w-[32px] animate-bounce ${setting}`} alt="Setting Icon" />
        <img src={CoinIcon} className={`absolute w-[32px] animate-bounce ${coin}`} alt="Coin Icon" />
        <img src={RentIcon} className={`absolute w-[32px] animate-bounce ${rent}`} alt="Rent Icon" />
      </div>
      <p
        className="absolute bottom-0 left-1/2 w-full -translate-x-1/2 translate-y-[40px] text-center text-[17px] font-black text-[#263116]"
        style={{
          textShadow: `
      -1px -1px 0 white,
      1px -1px 0 white,
      -1px 1px 0 white,
      1px 1px 0 white
    `,
        }}
      >
        {title}
      </p>
    </>
  );
}
